import { Template } from "chq";
import { defaultMontageTemplates, intelliaMontageTemplates, intuitiveMontageTemplates, ircMontageTemplates, microsoftMontageTemplates, santanderMontageTemplates } from "../sidebar/tabs/template/templates";

const getMontageTemplatesByOrg = (organizationName: string): Template[] => {
  if (organizationName === "Intellia Therapeutics") {
    return intelliaMontageTemplates;
  }
  if (organizationName === "Microsoft") {
    return [...microsoftMontageTemplates, ...defaultMontageTemplates];
  }
  if (organizationName === "Intuitive") {
    return [...intuitiveMontageTemplates, ...defaultMontageTemplates];
  }
  if (organizationName === "Santander") {
    return [...santanderMontageTemplates, ...defaultMontageTemplates];
  }
  if (organizationName === "International Rescue Committee") {
    return [...ircMontageTemplates, ...defaultMontageTemplates];
  }
  return defaultMontageTemplates;
};

export default getMontageTemplatesByOrg;
